<template>
    <div class="flex modal-mask mt-3">
        <div class="modal-wrapper relative" @click.self="$emit('close')">
            <div class="ml-auto flex arrow absolute"></div>

            <div class="modal-container flex flex-col">
                <div class="modal-body">
                    <div class="flex items-center justify-center mt-3">
                        <p class="flex font-bold">Ваш город: </p>
                        <p class="text-center">Екатеринбург?</p>
                    </div>
                </div>
                <div class="modal-footer flex justify-between mx-2 mt-2">
                    <slot name="footer flex justify-center text-center">
                        <button class="pink-button text-white" @click.self="$emit('close')">
                            Да
                        </button>
                        <button class="select-button text-grey-darkest font-bold text-sm">
                            Нет, выбрать
                        </button>
                    </slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>


export default {
  name: 'SelectCity',

  data() {
    return {
      ext: '',
      show: true,

    };
  },

  created() {
    const escapeHandler = (e) => {
      if (e.key === 'Escape' && this.show) {
        this.$emit('close');
      }
    };
    document.addEventListener('keydown', escapeHandler);
    this.$once('hook:destroyed', () => {
      document.removeEventListener('keydown', escapeHandler);
    });
  },

};

</script>

<style scoped>

    .modal-mask {
        z-index: 9998;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        vertical-align: middle;
    }

    .modal-container {
        width: 242px;
        height: 76px;
        box-shadow: 0 2px 4px rgba(168, 168, 168, 0.06);
        border-radius: 8px;
        background-color: #ffffff;
    }

    .modal-header h3 {
        width: 173px;
        height: 15px;
        color: #444444;
        font-family: "Montserrat Medium";
        font-size: 12px;
        font-weight: 500;
    }

    .pink-button {
        width: 65px;
        height: 30px;
        border-radius: 15px;
        background-color: #bd006c;
    }

    .select-button {
        width: 115px;
        height: 30px;
        border-radius: 15px;
        border: 1px solid #979797;
    }

    .modal-body {
        margin: 0 0;
    }

    .arrow {
        width: 21px;
        height: 14px;
        z-index: -1;
        margin-left: 108px !important;
        transform: rotate(-45deg);
        background-color: #ffffff;
    }

    /*
     * The following styles are auto-applied to elements with
     * transition="modal" when their visibility is toggled
     * by Vue.js.
     *
     * You can easily play with the modal transition by editing
     * these styles.
     */

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

</style>
